"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var Strategy;
(function (Strategy) {
    Strategy["LongStock"] = "LONG_STOCK";
    Strategy["ShortStock"] = "SHORT_STOCK";
    Strategy["BuyWrite"] = "BUY_WRITE";
    Strategy["Overwrite"] = "OVERWRITE";
    Strategy["PutHedge"] = "PUT_HEDGE";
    Strategy["LongCall"] = "LONG_CALL";
    Strategy["LongPut"] = "LONG_PUT";
    Strategy["ShortCall"] = "SHORT_CALL";
    Strategy["ShortPut"] = "SHORT_PUT";
    Strategy["LongCallSpread"] = "LONG_CALL_SPREAD";
    Strategy["LongPutSpread"] = "LONG_PUT_SPREAD";
    Strategy["ShortCallSpread"] = "SHORT_CALL_SPREAD";
    Strategy["ShortPutSpread"] = "SHORT_PUT_SPREAD";
    Strategy["RatioCallSpread"] = "RATIO_CALL_SPREAD";
    Strategy["LongStraddle"] = "LONG_STRADDLE";
    Strategy["ShortStraddle"] = "SHORT_STRADDLE";
    Strategy["LongStrangle"] = "LONG_STRANGLE";
    Strategy["ShortStrangle"] = "SHORT_STRANGLE";
    Strategy["LongCondor"] = "LONG_CONDOR";
    Strategy["ShortCondor"] = "SHORT_CONDOR";
    Strategy["ShortIronCondor"] = "SHORT_IRON_CONDOR";
    Strategy["LongCallButterfly"] = "LONG_CALL_BUTTERFLY";
    Strategy["LongPutButterfly"] = "LONG_PUT_BUTTERFLY";
    Strategy["ShortCallButterfly"] = "SHORT_CALL_BUTTERFLY";
    Strategy["ShortPutButterfly"] = "SHORT_PUT_BUTTERFLY";
    Strategy["ShortIronButterfly"] = "SHORT_IRON_BUTTERFLY";
    Strategy["Collar"] = "COLLAR";
})(Strategy = exports.Strategy || (exports.Strategy = {}));
function StrategyFromJSON(json) {
    return StrategyFromJSONTyped(json, false);
}
exports.StrategyFromJSON = StrategyFromJSON;
function StrategyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.StrategyFromJSONTyped = StrategyFromJSONTyped;
function StrategyToJSON(value) {
    return value;
}
exports.StrategyToJSON = StrategyToJSON;
